export enum RouteStatus {
    New = 0,
    Confirmed = 10,
    InWork = 20,
    ParcelPickedUp = 30,
    Canceled = 70,
    WaitingForRouteSheet = 90,
    WaitingForFinishConfirmation = 99,
    Finished = 100,
}
